/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { FeederWrapper } from "../FeederWrapper";

export class FeederWrapper__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(overrides?: Overrides): Promise<FeederWrapper> {
    return super.deploy(overrides || {}) as Promise<FeederWrapper>;
  }
  getDeployTransaction(overrides?: Overrides): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): FeederWrapper {
    return super.attach(address) as FeederWrapper;
  }
  connect(signer: Signer): FeederWrapper__factory {
    return super.connect(signer) as FeederWrapper__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): FeederWrapper {
    return new Contract(address, _abi, signerOrProvider) as FeederWrapper;
  }
}

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_feeder",
        type: "address",
      },
      {
        internalType: "address[]",
        name: "_assets",
        type: "address[]",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_feeder",
        type: "address",
      },
      {
        internalType: "address",
        name: "_vault",
        type: "address",
      },
      {
        internalType: "address[]",
        name: "_assets",
        type: "address[]",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_feeder",
        type: "address",
      },
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_feeder",
        type: "address",
      },
      {
        internalType: "address",
        name: "_vault",
        type: "address",
      },
      {
        internalType: "address",
        name: "_input",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_inputQuantity",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_minOutputQuantity",
        type: "uint256",
      },
    ],
    name: "mintAndStake",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_feeder",
        type: "address",
      },
      {
        internalType: "address",
        name: "_vault",
        type: "address",
      },
      {
        internalType: "address[]",
        name: "_inputs",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "_inputQuantities",
        type: "uint256[]",
      },
      {
        internalType: "uint256",
        name: "_minOutputQuantity",
        type: "uint256",
      },
    ],
    name: "mintMultiAndStake",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";
